import { APPLIED_JOB_REQUEST_REQUEST, APPLIED_JOB_REQUEST_SUCCESS, APPLIED_JOB_REQUEST_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "Job Action",
  result: null,
  msg: "",
  error: "",
};

const AppliedJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLIED_JOB_REQUEST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case APPLIED_JOB_REQUEST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case APPLIED_JOB_REQUEST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default AppliedJobsReducer;
